import { IBasePagingRes } from 'src/types/common.type';
import http from 'src/utils/http';

export default class BaseService<T, Q = {}, B = {}, C = {}> {
  url: string;

  constructor(url: string) {
    this.url = url;
  }

  public async list(query: Q) {
    const { data } = await http.get<IBasePagingRes<T>>(this.url, { params: query });
    return data;
  }

  public async select(query: Q) {
    const { data } = await http.get<IBasePagingRes<T>>(`${this.url}/select`, { params: query });
    return data;
  }

  public async detail(id: number) {
    const { data } = await http.get<T>(`${this.url}/${id}`);
    return data;
  }

  public async create(obj: B) {
    const { data } = await http.post<T>(this.url, obj);
    return data;
  }

  public async update(id: number, obj: C) {
    const { data } = await http.put<boolean>(`${this.url}/${id}`, obj);
    return data;
  }

  public async delete(id: number) {
    const { data } = await http.delete<boolean>(`${this.url}/${id}`);
    return data;
  }

  public async deleteMulti(ids: number[]) {
    const { data } = await http.delete<boolean>(this.url, { data: ids });
    return data;
  }
}
